module.exports = __webpack_public_path__ + "sb.svg?6899771fe71246ff7b4c91223f9e8f2f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sb.svg
// module id = 1120
// module chunks = 27